// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".labels{width:35px;height:35px}.labels>img{width:100%;height:100%}.el-dialog{height:42%!important;width:70%!important;margin-top:28vh!important;z-index:9999!important}.el-textarea{width:60vw!important}.el-dialog__wrapper{z-index:99999!important}.el-dialog__body{padding:0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
